// extracted by mini-css-extract-plugin
module.exports = {"Body":"styles_Body__Xod90"};